<template>
  <div class="home">
    <HeaderLandingNew />
    <div class="section-one section-mobile-app">
      <div class="so-content">
        <h1>Download MusicVerse</h1>
        <p>Your one-stop app for sacred music.</p>
        <div class="store-links">
          <a
            :href="appStoreUrl"
            class="content-logo"
            aria-label="App Store"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="@/assets/applestore-logo.png" class="content-logo" alt="App Store" />
          </a>
          <a
            :href="googlePlayUrl"
            class="content-logo"
            aria-label="Google Play"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="@/assets/googleplay-logo.png" class="content-logo" alt="Google Play" />
          </a>
          <a
            :href="appGalleryUrl"
            class="content-logo radius"
            aria-label="App Gallery"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="@/assets/huawei-logo.png" class="content-logo radius" alt="App Gallery" />
          </a>
        </div>
      </div>
    </div>
    <FooterLandingNew />
  </div>
</template>

<script>
import HeaderLandingNew from "@/components/HeaderLandingNew";
import FooterLandingNew from "@/components/FooterLandingNew";

export default {
  name: "MobileAppPage",
  data: () => ({
    appStoreUrl:
      process.env.VUE_APP_ALL_BUTTON_LINK_IOS ||
      "https://musicverse.onelink.me/vYmO/mainwebsite",
    googlePlayUrl:
      process.env.VUE_APP_ALL_BUTTON_LINK_ANDROID ||
      "https://musicverse.onelink.me/vYmO/mainwebsite",
    appGalleryUrl: "https://appgallery.huawei.com/#/app/C104486453",
  }),
  components: {
    HeaderLandingNew,
    FooterLandingNew,
  },
};
</script>

<style>
@import "../assets/stylesheets/landing.css";

.section-mobile-app {
  min-height: 560px;
}

.store-links {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.store-links .content-logo {
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/views/MobileApp.vue